export default "__VITE_ASSET__CZxe0TAU__"